import { FunctionComponent, HTMLProps } from "react"
import { Link, Route, useLocation } from "react-router-dom"
import RoutesWithNotFound from "utilities/routes-with-not-found"
import { TextProfileNav } from "views/profile/text.style"
import { BorderButtonProfile, ButtonHelperProfile } from '../../theme/profile'

function NestedRoutes({ definitions }: { definitions: any[] }) {

  const { pathname } = useLocation()

  const Tab: FunctionComponent<HTMLProps<HTMLButtonElement> | any> = ({ children, selected, helper, ...props }) => {
    return (
      <BorderButtonProfile selected={selected} className={`h-20 px-5 din font-bold text-sm uppercase transition-all relative whitespace-nowrap ${selected && 'border-b-4'}`}
        {...(props as any)}
      >
        {helper && <ButtonHelperProfile className="h-2 w-2 rounded-full absolute right-2 animate-ping"></ButtonHelperProfile>}
        <TextProfileNav className={`opacity-50 ${selected && 'opacity-100'}`}>
          {children}
        </TextProfileNav>
      </BorderButtonProfile>
    )
  }

  return (
    <>
      <nav className="w-screen">
        <ul className="flex overflow-x-auto">
          {definitions.map((definition: any, index: number) => {
            return (
              <li key={index}>
                <Link to={definition.url}>
                  <Tab onClick={() => gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: definition.label, value: '10' })} selected={pathname === definition.url} helper={definition.helper}>
                    {definition?.title}
                  </Tab>
                </Link>
              </li>
            )
          })}
        </ul>
      </nav>
      <RoutesWithNotFound>
        {definitions.map((definition: any, index: number) => <Route key={index} path={definition.path} component={definition.component} />)}
      </RoutesWithNotFound>
    </>
  )
}

export default NestedRoutes
